export default __webpack_public_path__ + "static/media/Navigation.9fa4bc5d.svg";